import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { Spin } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import WebScraperCustomPPI from "./features/web-scraper/web_scraper_custom_ppi";
import Signin from './features/SignIn/Signin';
import { UserProvider, useUser } from './context/UserContext';
import Account from './features/Account/Account';
import { initGA, logPageView } from './services/googleAnalytics';
import { auth } from './services/firebase';
import { signInAnonymously } from 'firebase/auth';

// A wrapper for <Route> that prevents access until the auth state is resolved.
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>;
  }

  if (!user) {
    // This should ideally not be reached if anonymous auth works correctly,
    // but it's a safe fallback.
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>;
  }

  return children;
};


// The main App component is now much cleaner.
function App() {
  const [userVar, setUser] = useState<any>(null);

  const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
      initGA(); // Initialize GA once when the app mounts
    }, []);

    useEffect(() => {
      logPageView(location.pathname + location.search);
    }, [location]);

    return null;
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in (either normally or anonymously)
        setUser(user);
      } else {
        // No user is signed in, so sign them in anonymously.
        signInAnonymously(auth).catch((error) => {
          console.error("Anonymous sign-in failed:", error);
          // Handle error appropriately in a real app
        });
      }
    });

    return unsubscribe;
  }, []);
  return (
    <UserProvider>
      <RouteTracker />
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute><WebScraperCustomPPI /></ProtectedRoute>}
        />
        <Route path="/signin" element={<Signin />} />
        <Route
          path="/account"
          element={<ProtectedRoute><Account /></ProtectedRoute>}
        />
      </Routes>
    </UserProvider>
  );
}

export default App;
